import { useWindowScroll } from '@mantine/hooks';

const SCROLL_OFFSET = 200;

export const useHomeHide = () => {
    const [scrollOffset] = useWindowScroll();

    return scrollOffset.y < SCROLL_OFFSET;
};
